export default angular.module('syWebChats', [])
    .directive('checkWebchatAvailablity', ['$filter', function ($filter) {
        return {
            restrict: 'A',
            link: function ($scope, $element, attrs) {
                window._inside = window._inside || [];
                $scope.availabletab = false;
                let chatLoaded;
                window._inside.push({
                    "action": "bind",
                    "name": "chatavailable",
                    "callback": function (available) {
                        chatLoaded = true;
                        if (available) {
                            $scope.availabletab = true;
                            var tab = $filter('filter')($scope.getTabs(), { id: attrs.tab })[0];
                            if (!tab) {
                                $scope.addTab({
                                    id: attrs.tab,
                                    label: attrs.tabLabel,
                                    icon: attrs.tabIcon || attrs.tab
                                });
                                $scope.$apply();
                            }
                            $scope.setActiveTab(attrs.tab);
                        } else {
                            $scope.availabletab = false;
                            $scope.setActiveTab($scope.getTabs()[0].id);
                        }
                    }
                });

                $scope.showtabSection = function () {
                    if ($scope.availabletab) {
                        return $scope.availabletab;
                    }
                    var tab = $filter('filter')($scope.getTabs(), { id: attrs.tab })[0];
                    if (tab) {
                        $scope.getTabs().splice(1, 1);
                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }
                    }
                    $scope.setActiveTab($scope.getTabs()[0].id);
                    return $scope.availabletab;

                };
                $scope.openChatButtonClick = function () {
                    if (chatLoaded) { // This is to check if INSIDE has finished loading.
                        insideFrontInterface.openChatPane();
                    } else {
                        chatRequested = true;
                    }
                    return false;
                };
            }
        };
    }])
    .directive('checkpromoavailablity', function () {
        return {
            restrict: 'A',
            link: function ($scope) {
                window._inside = window._inside || [];
                let chatLoaded;
                window._inside.push({
                    "action": "bind",
                    "name": "chatavailable",
                    "callback": function (available) {
                        chatLoaded = true;
                        $scope.available = available ? true : false;
                        $scope.$apply();
                    }
                });
                $scope.openChatButtonClick = function () {
                    if (chatLoaded) { // This is to check if INSIDE has finished loading.
                        insideFrontInterface.openChatPane();
                    } else {
                        chatRequested = true;
                    }
                    return false;
                };
            }
        };
    });